import Config from '../config/config'
import firebase from 'firebase/app'
import 'firebase/storage'

export function initFirebase() {
  const config = {
    apiKey: Config.firebaseApiKey,
    authDomain: Config.firebaseAuthDomain,
    databaseURL: Config.firebaseDatabaseURL,
    projectId: Config.firebaseProjectId,
    storageBucket: Config.firebaseStorageBucket,
    messagingSenderId: Config.firebaseMessagingSenderId,
  }

  firebase.initializeApp(config)
  window.firebase = firebase
  return firebase
}



// WEBPACK FOOTER //
// ./src/apis/firebase.js